import React from "react";
import styled from "styled-components";

import colors from "../colors";

const Connector = styled.div`
  height: 100%;
  width: 1px;
  background-color: ${({ color }) => color || colors.mediumDarkGrey};
  margin: 0 auto;
`;

const genConnectorFormatter = (
  {
    primaryColor = colors.mediumDarkGrey,
    completedColor = colors.mediumDarkGrey
  } = {}
) => ({ completed }) => (
  <Connector color={completed ? completedColor : primaryColor} />
);

export { Connector, genConnectorFormatter };



// WEBPACK FOOTER //
// ./src/common/verticalSteps/connector.js